let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("dSxO1")]).then(() => parcelRequire('ekO4Z'));